import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { Redirect } from 'react-router-dom';

export default class BecomeAMentor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            submit: true,
            canContact: true,
        };
    }

    canSubmit = () => {
        return (this.props.store.getState().newMentor.mentorName.length > 0 &&
                this.props.store.getState().newMentor.profession.length > 0 &&
                this.props.store.getState().newMentor.reason.length > 0 &&
                this.props.store.getState().newMentor.twitter.length > 0 &&
                this.props.store.getState().newMentor.email.length > 0);
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
        window.localStorage.setItem("isMentee", true);
    };

    handleNameChange = (event, newValue) => {
        this.props.store.dispatch({type: 'SET_NAME', mentorName: newValue});
        if (this.canSubmit()) {
            this.setState({submit: false});
        }
    };

    handleProfessionChange = (event, newValue) => {
        this.props.store.dispatch({type: 'SET_PROF', profession: newValue});
        if (this.canSubmit()) {
            this.setState({submit: false});
        }
    };

    handleReasonChange = (event, newValue) => {
        this.props.store.dispatch({type: 'SET_REASON', reason: newValue});
        if (this.canSubmit()) {
            this.setState({submit: false});
        }
    };

    handleTwitterChange = (event, newValue) => {
        this.props.store.dispatch({type: 'SET_TWITTER', twitter: newValue});
        if (this.canSubmit()) {
            this.setState({submit: false});
        }
    };

    handleEmailChange = (event, newValue) => {
        this.props.store.dispatch({type: 'SET_EMAIL', email: newValue});
        if (this.canSubmit()) {
            this.setState({submit: false});
        }
    };

    handleSubmit = () => {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("POST", '/newmentor', true); // false for synchronous request
        xmlHttp.setRequestHeader("Content-type", "application/json");
        xmlHttp.send(JSON.stringify(this.props.store.getState().newMentor));
        this.handleClose();
    };

    updateCheck = (event, isInputChecked) => {
        this.setState({canContact: isInputChecked});
        this.props.store.dispatch({type: 'SET_CAN_CONTACT', canContact: isInputChecked});
    };

    render() {
        const { isAuthenticated } = this.props.auth;
        if (!isAuthenticated()) {
           return this.props.auth.login();
        }

        const actions = [
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleClose}
            />,
            <FlatButton
              label="Submit"
              primary={true}
              disabled={this.state.submit}
              onClick={this.handleSubmit}
            />,
          ];

          const { open } = this.state;

          if (!open) {
              return <Redirect to="/" />
          }

          return (
              <MuiThemeProvider>
            <div>
                {/* <FlatButton labelStyle={{color: 'white'}} label="Become A Mentor" onClick={this.handleOpen} /> */}
                <Dialog
                title="Become A Mentor"
                actions={actions}
                modal={true}
                open={this.state.open}>
                    <div>
                        {/* <h1>Coming Soon!</h1> */}
                        <TextField style={{width: '100%'}} hintText="Name" onChange={this.handleNameChange} />
                        <br />
                        <TextField style={{width: '100%'}} hintText="Profession" onChange={this.handleProfessionChange} />
                        <br />
                        <TextField style={{width: '100%'}} hintText="Why do you want to be a mentor" multiLine={true} onChange={this.handleReasonChange}  />
                        <br />
                        <TextField style={{width: '100%'}} hintText="Twitter" onChange={this.handleTwitterChange} />
                        <br />
                        <TextField style={{width: '100%'}} hintText="Email" onChange={this.handleEmailChange}  />
                        <br />
                        <Checkbox checked={this.state.canContact} label="May we contact you to ask you a few questions?" onCheck={this.updateCheck} />
                    </div>
                </Dialog>
          </div>
          </MuiThemeProvider>
          );
    }
}


// WEBPACK FOOTER //
// ./src/components/BecomeAMentor.js